import useDoc from '@actions/services/firestore/browser/prompt/file/use';
import type { UseFileOptions, UseFileResult } from './types';

const useFile = ({ promptId, fileId }: UseFileOptions): UseFileResult => {
    return useDoc(promptId, fileId);
};

export default useFile;
